import { render, staticRenderFns } from "./dlgInfomation.vue?vue&type=template&id=22c73638&scoped=true&"
import script from "./dlgInfomation.vue?vue&type=script&lang=js&"
export * from "./dlgInfomation.vue?vue&type=script&lang=js&"
import style0 from "./dlgInfomation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dlgInfomation.vue?vue&type=style&index=1&id=22c73638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c73638",
  null
  
)

export default component.exports